<div class="monitor_info-box-simple-container">
  <div class="monitor_info-box">
    @if (patient) {
      <span>{{patientsService.getDisplayName(patient)}}</span>
    } @else {
      <app-load class="text--loader"></app-load>
    }
  </div>
  <div class="monitor_info-box" [ngClass]="{ 'monitor_info-box--complex' : !!bundle }">
    @if (patient) {
      <span>{{ patient?.date_of_birth | date: preferencesService.defaultDateFormat.value }}&nbsp;&nbsp;{{ patient?.gender?.name | titlecase }}</span>
      @if (bundle) {
        <span id="test-bundle-info">{{ monitorTestService.getBundleInfo(test, bundle) }}</span>
      }
    } @else {
      <app-load class="text--loader"></app-load>
    }
  </div>
  <div class="monitor_info-box monitor_info-box--title">
    @if (!testLoading) {
      <span>{{ monitorTestService.getDisplayTitle(test?.test_group) }}</span>
      @if (isRegionShown && (currentRegion !== null)) {
        <span>(&#35;{{ currentRegion + 1 }})</span>
      }
      @if (!screen && bundle && (test?.status?.name === 'Pending')) {
        <span>
          <span>&#58;&nbsp;</span>{{ 'pending' | translate }}
        </span>
      }
      @if (!isTestDone && screen?.name) {
        <span>&#58;&nbsp;</span>
      }
      @if (!isTestDone && screen?.name) {
        <span id="test-screen-name">{{ getScreenName() }}</span>
      }
    } @else {
      <app-load class="text--loader"></app-load>
    }
  </div>
  <div class="monitor_info-box monitor_info-box--controls">
    @if (isTestDone) {
      <span class="text--blink text--uppercase">&nbsp;{{ 'testDone' | translate }}</span>
    }
    @if (isTestSyncing) {
      <span class="text--blink text--uppercase">&nbsp;{{ 'testSyncing' | translate }}</span>
    }
    @if (!isTestDone && !isTestSyncing) {
      <app-controls
        [screen]="screen"
        [testGroup]="test?.test_group"
        [device]="device"
        (actionClicked)="onActionClicked.emit($event)">
      </app-controls>
    }
  </div>
</div>

<div class="monitor_info-box monitor_info-box--medium monitor_device-box">
  @if (device?.capabilities?.volume_control_supported && !!screen && !isTestDone) {
    <div class="monitor_device-box-volume-container">
      <app-volume-control
        [volume]="device?.volume"
        (actionClicked)="onActionClicked.emit($event)">
      </app-volume-control>
    </div>
  }
  <div class="monitor_device-box-image-container">
    <img src="./assets/images/headset.svg" alt="headset device">
    <div class="monitor_device-title" [matTooltip]="device?.name?.toUpperCase() || ''">
      @if (!deviceLoading) {
        {{ device?.name || ('unknownDevice' | translate) }}
      } @else {
        <app-load class="text--loader"></app-load>
      }
    </div>
    @if (device?.ipd || patient?.ipd) {
      <div
        class="monitor_device-box-ipd-container">
        <i
          class="fas fa-eye"
          matTooltip="{{!!patient?.ipd ? ('patientIpd' | translate) : ('deviceIpd' | translate)}}&#58; {{ patient?.ipd?.toFixed(2) || device?.ipd?.toFixed(2) }}">
        </i>
      </div>
    }
  </div>
  @if (batteryPercentage) {
    <app-battery
      [batteryPercentage]="batteryPercentage">
    </app-battery>
  }
  @if (streamable && screen && !isTestDone && !isChoiceDevice() && authService.isDeviceStreamingAvailable) {
    <div
      class="monitor_device-box-stream-container"
      [matTooltip]="streamPopupVisible ? ('stopStreaming' | translate | titlecase) : ('streamTest' | translate | titlecase)"
      [ngClass]="{ 'text--blink': streamPopupVisible }">
      <i
        class="fas fa-stream"
        (click)="onStreamOpen.emit(streamComponent)">
      </i>
    </div>
  }
  @if (!isTestDone && !isTestSyncing) {
    <div
      class="monitor_device-box-cancel-container">
      <i
        class="fas fa-ban"
        matTooltip="{{ 'cancelTest' | translate | titlecase }}"
        (click)="onCancelTest()">
      </i>
    </div>
  }
</div>
<div class="monitor_info-box monitor_info-box--last monitor_image-box">
  <img
    src="{{utilityService.isWhiteLabelDomain ? './assets/images/logo-white-label.svg' : './assets/images/logo.svg'}}"
    alt="Olleyes logo">
  </div>


  @if (streamable) {
    <app-stream
      [ngClass]="{ 'hidden': !streamPopupVisible }"
      [isSingleImage]="isSingleImage"
      [isV2Streaming]="isV2Streaming"
      [streamPending]="streamingService.streamPending"
      [isUpper]="authService.isTechallAdmin"
      [isConnectionFail]="streamingService.deviceConnectionFailed"
      (close)="onStreamClose.emit()">
    </app-stream>
  }

  @if (deviceActionLoading) {
    <app-loader [transparent]="true"></app-loader>
  }
